/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AutoTestEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestEnabledSettingParser.decode(input).map(res => new AutoTestEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestEnabledSettingParser.encode(data);
    }
    static schema() {
        return AutoTestEnabledSettingParser.schema();
    }
}
